(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesktop = window.matchMedia('(min-width: 990px) and (pointer: fine)').matches;
  const isHome = document.body.classList.contains('page-index');
  const isProduct = document.body.classList.contains('template-product');
  const isPage = document.body.classList.contains('page-page');
  const isPolicy = document.body.classList.contains('page-policy');

  /* ── Scroll progress bar ── */
  function initScrollProgress() {
    const bar = document.createElement('div');
    bar.className = 'trisole-scroll-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    function update() {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? Math.min(scrollTop / docHeight, 1) : 0;
      bar.style.setProperty('--trisole-scroll', progress);
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── Premium header state ── */
  function initHeaderState() {
    const header = document.querySelector('.section-header');
    if (!header) return;

    const onScroll = function () {
      header.classList.toggle('trisole-header-scrolled', window.scrollY > 40);
      header.classList.toggle('trisole-header-deep', window.scrollY > 320);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Floating back-to-top button ── */
  function initBackToTop() {
    if (document.querySelector('.trisole-to-top')) return;

    const btn = document.createElement('button');
    btn.className = 'trisole-to-top';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 19V5M12 5L5 12M12 5L19 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    document.body.appendChild(btn);

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  }

  /* ── Intersection reveal ── */
  function initReveal(root) {
    if (reducedMotion) {
      root.querySelectorAll('.trisole-reveal').forEach(function (el) {
        el.classList.add('trisole-reveal--visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('trisole-reveal--visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    root.querySelectorAll('.trisole-reveal:not(.trisole-reveal--visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Auto-tag homepage sections for reveal ── */
  function tagHomeSections() {
    document.querySelectorAll('.template-index shopify-section').forEach(function (section, index) {
      if (section.id && section.id.includes('slideshow')) return;

      const inner =
        section.querySelector('.featured_collection_home') ||
        section.querySelector('.featured-product') ||
        section.querySelector('.trisole-brand-story__inner') ||
        section.querySelector('.sneaker-sizes-hero') ||
        section.querySelector('.testimonial') ||
        section.querySelector('.icons_with_feature_inner') ||
        section.querySelector('.trisole-premium-cta__inner') ||
        section.querySelector('.trisole-shop-gender__header') ||
        section.querySelector('.collection-list-wrapper') ||
        section.querySelector('.image-with-text') ||
        section.querySelector('.section-heading');

      if (inner && !inner.classList.contains('trisole-reveal')) {
        inner.classList.add('trisole-reveal');
        inner.style.setProperty('--trisole-section-index', index);
      }
    });
  }

  /* ── Counter animation ── */
  function animateCount(el) {
    const target = parseFloat(el.dataset.trisoleCount);
    const suffix = el.dataset.trisoleSuffix || '';
    if (Number.isNaN(target)) return;

    const duration = 1400;
    const start = performance.now();
    const isFloat = target % 1 !== 0;

    function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;
      el.textContent = (isFloat ? current.toFixed(1) : Math.round(current)) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function initCounters(root) {
    root.querySelectorAll('[data-trisole-count]').forEach(function (el) {
      if (el.dataset.trisoleCounted) return;
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            el.dataset.trisoleCounted = 'true';
            animateCount(el);
            observer.unobserve(el);
          });
        },
        { threshold: 0.4 }
      );
      observer.observe(el);
    });
  }

  /* ── Stagger product cards ── */
  function initStaggerCards() {
    if (reducedMotion) return;

    const cards = document.querySelectorAll(
      '.template-index .featured_collection_home .grid__item, .template-index .featured-product .grid__item, .template-index .collection-list__item.grid__item'
    );

    cards.forEach(function (item, i) {
      if (item.dataset.trisoleStaggered) return;
      item.dataset.trisoleStaggered = '1';
      item.style.setProperty('--trisole-stagger', i % 8);
      item.classList.add('trisole-card-stagger');

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('trisole-card-stagger--visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
      );

      observer.observe(item);
    });
  }

  /* ── Section eyebrow labels ── */
  function initEyebrows() {
    const map = {
      featured_collection: 'Curated For You',
      trisole_brand: 'Our Promise',
      image_with_text: 'Shop By Style',
      trisole_shop_gender: 'Shop By Style',
      featured_product: 'Fresh Drops',
      sneaker_sizes: 'Find Your Fit',
      testimonials: 'Customer Love',
      collection_list: 'Collections',
      trisole_premium: 'Why Trisole',
      icons_with_feature: 'Shop With Confidence'
    };

    Object.keys(map).forEach(function (key) {
      document
        .querySelectorAll('.template-index shopify-section[id*="' + key + '"] .section-heading .title')
        .forEach(function (title) {
          if (!title.dataset.eyebrow) title.dataset.eyebrow = map[key];
        });
    });

    document.querySelectorAll('.template-index .sneaker-sizes-heading').forEach(function (title) {
      if (!title.dataset.eyebrow) title.dataset.eyebrow = 'Find Your Fit';
    });
  }

  /* ── Magnetic buttons ── */
  function initMagnetic() {
    if (!isDesktop || reducedMotion) return;

    const targets = document.querySelectorAll(
      '.template-index .trisole-premium-cta__button, .template-index .trisole-brand-story__cta, .template-index .trisole-hero-premium .banner__buttons .button, .template-index .collection__view-all .button'
    );

    targets.forEach(function (el) {
      const strength = 0.32;

      el.addEventListener('mousemove', function (e) {
        const rect = el.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        el.style.transform = 'translate(' + x * strength + 'px, ' + y * strength + 'px)';
      });

      el.addEventListener('mouseleave', function () {
        el.style.transform = '';
      });
    });
  }

  /* ── 3D card tilt ── */
  function initCardTilt() {
    if (!isDesktop || reducedMotion) return;

    const cards = document.querySelectorAll(
      '.template-index .trisole-premium-cta__card, .template-index .collection-list__item .card, .template-index .trisole-stat'
    );

    cards.forEach(function (card) {
      if (card.dataset.trisoleTilt) return;
      card.dataset.trisoleTilt = '1';
      card.style.transformStyle = 'preserve-3d';
      const max = 7;

      card.addEventListener('mousemove', function (e) {
        const rect = card.getBoundingClientRect();
        const px = (e.clientX - rect.left) / rect.width;
        const py = (e.clientY - rect.top) / rect.height;
        const rx = (0.5 - py) * max;
        const ry = (px - 0.5) * max;
        card.style.transform =
          'perspective(900px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) translateY(-6px)';
      });

      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* ── Hero cursor glow ── */
  function initHeroGlow() {
    if (!isDesktop || reducedMotion) return;

    const hero = document.querySelector('.template-index .trisole-hero-premium');
    if (!hero || hero.querySelector('.trisole-hero-glow')) return;

    const glow = document.createElement('div');
    glow.className = 'trisole-hero-glow';
    glow.setAttribute('aria-hidden', 'true');
    hero.appendChild(glow);

    hero.addEventListener('mousemove', function (e) {
      const rect = hero.getBoundingClientRect();
      glow.style.setProperty('--gx', e.clientX - rect.left + 'px');
      glow.style.setProperty('--gy', e.clientY - rect.top + 'px');
      glow.style.opacity = '1';
    });

    hero.addEventListener('mouseleave', function () {
      glow.style.opacity = '0';
    });
  }

  /* ── Enrich mega menus (remove empty feel, add content) ── */
  function enhanceMegaMenus() {
    if (!isDesktop) return;

    const links = [
      { label: 'New Arrivals', url: '/collections/new-arrivals' },
      { label: 'Men', url: '/collections/men' },
      { label: 'Women', url: '/collections/women' },
      { label: 'Best Sellers', url: '/collections/all' },
      { label: 'Sale', url: '/collections/sale-discounted', sale: true }
    ];

    const trust = [
      { text: '100% Authentic' },
      { text: '24h Dispatch' },
      { text: '7-Day Returns' },
      { text: 'Nationwide COD' }
    ];

    document.querySelectorAll('.mega-menu__content').forEach(function (content) {
      if (content.querySelector('.trisole-mega-footer')) return;
      if (content.querySelector('.trisole-mega-panel')) return;

      const footer = document.createElement('div');
      footer.className = 'trisole-mega-footer page-width';

      const linksHtml = links
        .map(function (l) {
          return '<a class="' + (l.sale ? 'is-sale' : '') + '" href="' + l.url + '">' + l.label + '</a>';
        })
        .join('');

      const trustHtml = trust
        .map(function (t) {
          return '<span>' + t.text + '</span>';
        })
        .join('');

      footer.innerHTML =
        '<div class="trisole-mega-footer__links">' + linksHtml + '</div>' +
        '<div class="trisole-mega-footer__trust">' + trustHtml + '</div>';

      content.appendChild(footer);
    });
  }

  /* ── Hero slideshow: unique product tabs + correct product card per slide ── */
  function initHeroSlideshowTabs() {
    if (!isHome) return;

    document.querySelectorAll('.template-index .trisole-hero-premium.main_slider').forEach(function (sectionRoot) {
      const shopifySection = sectionRoot.closest('.shopify-section') || sectionRoot;
      const slides = shopifySection.querySelectorAll('.slide');
      if (slides.length < 2) return;

      function shortLabel(text) {
        if (!text) return '';
        var label = text.trim();
        if (label.length > 26) label = label.slice(0, 24) + '…';
        return label;
      }

      slides.forEach(function (slide) {
        var titleEl = slide.querySelector('.banner_product .full-unstyled-link, .product-slide .full-unstyled-link');
        if (titleEl && titleEl.textContent.trim()) {
          slide.dataset.slideTabLabel = shortLabel(titleEl.textContent);
        }
      });

      var paginationContainer = shopifySection.querySelector('.slider-pagination-numbers');

      function refreshPaginationLabels() {
        if (!paginationContainer) return;
        var buttons = paginationContainer.querySelectorAll('.swiper-pagination-bullet');
        buttons.forEach(function (btn, index) {
          var slide = slides[index];
          var label = slide && (slide.dataset.slideTabCode || slide.dataset.slideTabLabel);
          if (label) {
            btn.textContent = label;
            btn.setAttribute('aria-label', 'Show ' + label);
          }
        });
      }

      function syncProductVisibility() {
        slides.forEach(function (slide) {
          var active = slide.classList.contains('active');
          slide.style.zIndex = active ? '2' : '1';
          slide.querySelectorAll('.product_slide').forEach(function (card) {
            card.style.visibility = active ? 'visible' : 'hidden';
            card.style.pointerEvents = active ? 'auto' : 'none';
          });
        });
      }

      function refreshHeroTabs() {
        refreshPaginationLabels();
        syncProductVisibility();
      }

      setTimeout(refreshHeroTabs, 600);
      setTimeout(refreshHeroTabs, 1500);

      slides.forEach(function (slide) {
        new MutationObserver(refreshHeroTabs).observe(slide, {
          attributes: true,
          attributeFilter: ['class']
        });
      });

      if (paginationContainer) {
        paginationContainer.addEventListener('click', function () {
          setTimeout(refreshHeroTabs, 80);
        });
      }

      var prevBtn = shopifySection.querySelector('.prev__button');
      var nextBtn = shopifySection.querySelector('.next__button');
      if (prevBtn) prevBtn.addEventListener('click', function () { setTimeout(refreshHeroTabs, 80); });
      if (nextBtn) nextBtn.addEventListener('click', function () { setTimeout(refreshHeroTabs, 80); });
    });
  }

  /* ── Subtle hero parallax ── */
  function initHeroParallax() {
    if (reducedMotion) return;

    const hero = document.querySelector('.trisole-hero-premium .slide.active .slideshow__media img');
    if (!hero) return;

    window.addEventListener(
      'scroll',
      function () {
        const y = Math.min(window.scrollY * 0.18, 80);
        hero.style.transform = 'scale(1.04) translateY(' + y + 'px)';
      },
      { passive: true }
    );
  }

  function boot() {
    if (isHome) {
      initScrollProgress();
      tagHomeSections();
      initReveal(document);
      initCounters(document);
      initStaggerCards();
      initEyebrows();
      initMagnetic();
      initCardTilt();
      initHeroGlow();
      enhanceMegaMenus();
      if (!document.getElementById('footer_scroll')) {
        initBackToTop();
      }
      initHeroSlideshowTabs();
      window.setTimeout(initHeroParallax, 2000);
    } else if (isPage || isPolicy) {
      initReveal(document);
    }
    initHeaderState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    tagHomeSections();
    initReveal(e.target);
    initCounters(e.target);
    initStaggerCards();
    initEyebrows();
    initMagnetic();
    initCardTilt();
    initHeroGlow();
    enhanceMegaMenus();
    initHeroSlideshowTabs();
  });
})();
